export const RECEIVE_APPLICATIONS = 'RECEIVE_APPLICATIONS';
export const SEARCH_FIRMS = 'SEARCH_FIRMS';